// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2t2sk","error":"Textarea_error__2okBA","readonly":"Textarea_readonly__2F1nP","disabled":"Textarea_disabled__ajgw9"};